import type { AudioAsset } from "@/components/assets/AudioAsset.js";
import type { MusicTrack } from "@rosette/web_components/src/assets/MusicTrack.js";
import { Rune } from "@rosette/ts/src/business/Rune.js";
import { Optional } from "@rosette/ts/src/util/Optional.js";


export class MusicAsset {

    private readonly track: MusicTrack;
    private readonly audio: AudioAsset;
    private readonly activeTrack: Rune<Optional<MusicAsset>>;
    private readonly playing: Rune<boolean>;

    constructor(
        track: MusicTrack,
        audio: AudioAsset,
        activeTrack: Rune<Optional<MusicAsset>>,
    ) {
        this.track = track;
        this.audio = audio;
        this.activeTrack = activeTrack;
        this.playing = new Rune<boolean>(false);
        this.audio.addPlayingListener((playing, paused) => {
            this.playing.set(playing);

            if (playing || paused) {
                this.activeTrack.set(Optional.of(this));
            } else {
                const current = this.activeTrack.get();
                if (current.isPresent() && current.get() === this) {
                    this.activeTrack.set(Optional.empty(), current);
                }
            }
        });
    }

    getTrack(): MusicTrack {
        return this.track;
    }

    getPlayingRune(): Rune<boolean> {
        return this.playing;
    }

    isPlaying(): boolean {
        return this.audio.isPlaying();
    }

    tryPlay(): boolean {
        if (this.audio.isPlaying())
            return true;
        if (!this.audio.isLoaded())
            return false;

        return !isNaN(this.audio.play());
    }

    pause() {
        this.audio.pause();
    }
}
